module.exports = __webpack_public_path__ + "static/media/collage-photo-4.a4d05f00.jpg";